import { NavLink } from '../ui';
import styles from './DesignCategory.module.css';
export function MkCostCalculatorWidget() {
    return (
        <div className={styles.desIdnewyellotiles}>
            <div className={styles.desyrlloTile}>
                <div className={styles.desInuptest}>
                    <strong>Know Your
                        Kitchen Cost in
                        3 Quick Steps.</strong>
                </div>
                <p>Instant & Hassle-Free.</p>
            </div>
            <NavLink href={process.env.SITE_URL + "/in/modular-kitchen-cost-calculator"}>
            <div className={styles.desLyellrtext}>
                <span>Calculate Now</span>
                <span style={{fontSize: '30px'}}>&#10230;</span>
            </div>
            </NavLink>
        </div>
    )
}